import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';

// Layout Components
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/shared/ScrollToTop';
import SiteHeader from './components/shared/SiteHeader';

// Pages
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Team from './pages/Team/Team';
import MemberProfile from './pages/Team/MemberProfile';
import Membership from './pages/Membership/Membership';
import Join from './pages/Join/Join';
import Blog from './pages/Blog/Blog';
import BlogPost from './pages/Blog/Blogpost';
import Gallery from './pages/Gallery/Gallery';
import Contact from './pages/Contact/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import GetInvolved from './pages/GetInvolved/GetInvolved';
import Shop from './pages/Shop/Shop';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminRoute from './components/admin/AdminRoute';
import { AdminAuthProvider } from './context/AdminAuthContext';
import NotFound from './pages/NotFound/NotFound';

function PublicLayout() {
  return (
    <div className="app">
      <SiteHeader />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AdminAuthProvider>
      <Router>
        <ScrollToTop />

        <Routes>
          {/* Admin: full screen, no public header/footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />

          {/* Public site */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/team/:slug" element={<MemberProfile />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/join" element={<Join />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </AdminAuthProvider>
  );
}

export default App;